import { render, staticRenderFns } from "./BuyerCreatives.vue?vue&type=template&id=bc996e76"
import script from "./BuyerCreatives.vue?vue&type=script&lang=js"
export * from "./BuyerCreatives.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports